import Vue from "vue";
import { VTextField, VTextarea, VForm, VSelect, VCheckbox } from "vuetify/lib";

Vue.component("v-text-field", VTextField);
Vue.component("v-textarea", VTextarea);
Vue.component("v-select", VSelect);
Vue.component("v-checkbox", VCheckbox);

Vue.component("v-form", VForm);

export default {};
